import { render } from "./card-result-preview.vue?vue&type=template&id=4423c41b&scoped=true&ts=true"
import script from "./card-result-preview.vue?vue&type=script&lang=ts"
export * from "./card-result-preview.vue?vue&type=script&lang=ts"

import "./card-result-preview.vue?vue&type=style&index=0&id=4423c41b&lang=scss&scoped=true"

import exportComponent from "D:\\project\\haocai\\h5\\kousai-group\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4423c41b"]])

export default __exports__